import React from 'react';

interface NoPresenceIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	stroke?: string;
}

export function NoPresenceIcon({
	width = 24,
	height = 24,
	stroke = 'currentColor',
	...props
}: Readonly<NoPresenceIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx={12} cy={12} r={11} stroke={stroke} strokeWidth={2} />
			<text x={12} y={16.5} fill={stroke} fontSize={20} fontWeight={600} textAnchor="middle" fontFamily="inherit">
				x
			</text>
		</svg>
	);
}
